import React from 'react';
import { FaArrowUp } from 'react-icons/fa';
import styles from './index.module.scss';
import { useScrollTo } from '@jokerdad/hooks';

var BackToTopButton = function BackToTopButton() {
  var backToTop = useScrollTo();
  return /*#__PURE__*/React.createElement("button", {
    className: styles.button,
    onClick: backToTop
  }, /*#__PURE__*/React.createElement(FaArrowUp, {
    className: styles.icon
  }));
};

export default BackToTopButton;